// import pages from './modules/pages';
import app from './modules/app';

export default {  
   modules: {  
       // pages,
       app
   },   
   strict: true,
};


// WEBPACK FOOTER //
// ./src/vuex/store.js